export default {
  apiUrl: import.meta.env.VITE_API_URL,
  isDummyMode: import.meta.env.VITE_DUMMY_MODE === 'true'
};
